import { Link } from "react-router-dom";

export default function LegalPage({ kicker, title, intro, sections, updated }) {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-16">
      <div className="kicker mb-4">{kicker}</div>
      <h1 className="font-display text-4xl md:text-5xl leading-tight">{title}</h1>
      {updated && (
        <div className="mt-3 text-xs text-white/40 font-mono-alt tracking-[0.14em] uppercase">
          Last updated · {updated}
        </div>
      )}
      {intro && <p className="mt-8 text-white/70 leading-relaxed max-w-3xl">{intro}</p>}
      <div className="mt-12 space-y-10">
        {sections.map((s, i) => (
          <section key={i} className="border-t border-white/[0.08] pt-8">
            <h2 className="font-display text-2xl leading-tight" data-testid={`legal-section-${i}`}>{s.h}</h2>
            <div className="mt-4 space-y-4 text-white/70 leading-relaxed">
              {s.body.map((p, j) =>
                typeof p === "string" ? (
                  <p key={j}>{p}</p>
                ) : (
                  <ul key={j} className="space-y-2 pl-5 list-disc marker:text-white/30">
                    {p.map((li, k) => <li key={k}>{li}</li>)}
                  </ul>
                )
              )}
            </div>
          </section>
        ))}
      </div>
      <div className="mt-16 border-t border-white/[0.08] pt-8 flex flex-wrap gap-4">
        <Link to="/privacy" className="text-xs text-white/50 hover:text-white font-mono-alt tracking-[0.14em] uppercase" data-testid="legal-link-privacy">Privacy Policy</Link>
        <Link to="/terms" className="text-xs text-white/50 hover:text-white font-mono-alt tracking-[0.14em] uppercase" data-testid="legal-link-terms">Terms</Link>
        <Link to="/disclaimer" className="text-xs text-white/50 hover:text-white font-mono-alt tracking-[0.14em] uppercase" data-testid="legal-link-disclaimer">Disclaimer</Link>
      </div>
    </div>
  );
}
